import { Navigate, useParams } from "react-router-dom";

/** Notifications and emails link to the canonical `/community/<id>` — this works out which app the
 *  reader is actually signed in to and sends them there, so the link never lands on a login page. */
export default function CommunityBridge() {
  const { id } = useParams();
  const suffix = id ? `/${id}${window.location.search}` : window.location.search;
  if (localStorage.getItem("fm_token_driver")) {
    return <Navigate to={`/portal/driver/community${suffix}`} replace />;
  }
  if (localStorage.getItem("fm_token_office")) {
    return <Navigate to={`/app/community${suffix}`} replace />;
  }
  if (localStorage.getItem("fm_token_admin")) {
    return <Navigate to={`/admin/community${suffix}`} replace />;
  }
  return <Navigate to="/login" replace />;
}
